/* Google API Promise */
const loadedGoogleMapsAPI = new Promise((resolve, reject) => {
  try {
    const baseApiUrl = 'https://maps.googleapis.com';
    const callbackName = 'googleApiInit';
    const apiOptions = {
      key: process.env.GOOGLE_API_KEY,
      libraries: 'places',
      callback: callbackName,
    };
    const optionsURI = Object.keys(apiOptions)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(apiOptions[key])}`)
      .join('&');

    const googleAPIScript = document.createElement('script');
    googleAPIScript.setAttribute('src', `${baseApiUrl}/maps/api/js?${optionsURI}`);
    googleAPIScript.setAttribute('async', '');
    googleAPIScript.setAttribute('defer', '');
    document.body.appendChild(googleAPIScript);
    window[callbackName] = resolve;
  } catch (err) {
    reject(err);
  }
});

export { loadedGoogleMapsAPI as default };



// WEBPACK FOOTER //
// ./src/libs/googleAPI.js